import { render, staticRenderFns } from "./DrawnNumbersBox.vue?vue&type=template&id=8255329c&scoped=true"
import script from "./DrawnNumbersBox.vue?vue&type=script&lang=js"
export * from "./DrawnNumbersBox.vue?vue&type=script&lang=js"
import style0 from "./DrawnNumbersBox.vue?vue&type=style&index=0&id=8255329c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8255329c",
  null
  
)

export default component.exports